<template>
  <div
    tabindex="0"
    :data-id="objectModelAction.client_id"
    :data-type="objectModelAction.action_type"
    class="form-element"
    :class="propertyClasses"
    @focus="replaceIdInRoute"
    @click.stop="replaceIdInRoute">
    <row class="title-bar">
      <column>
        <strong>{{ObjectModelActionDefinition.getDisplayName(objectModelAction.action_type)}}</strong>
      </column>
      <suffix v-if="isMoveDestroyable">
        <move-destroy
          :card="objectModelAction"
          @remove:card="remove"
          class="suffix"
        ></move-destroy>
      </suffix>
      <suffix v-else>
        <icon class="locked"></icon>
        <span class="sr-only">Action Locked</span>
      </suffix>
    </row>
    <row>
      <column class="row-title" v-if="objectModelAction.can(ObjectModelActionCapability.labelable)">
        <object-model-action-labelable
          :object-model-action="objectModelAction"></object-model-action-labelable>
      </column>
    </row>

    <component
      :is="getComponentByType(objectModelAction.action_type)"
      :object-model-action="objectModelAction"
      @remove="remove"></component>
  </div>
</template>

<script lang="ts">
  import Vue from "vue";
  import actionBaseMixin from "../mixins/action-base-mixin";
  import routerMixin from "../../../common/mixins/routerMixin";
  import {ObjectModelActionCapability} from "../../../common/models/objectModelActions/objectModelActionCapability";
  import ObjectModelActionDefinition from "../../../common/models/objectModelActions/objectModelActionDefinition";
  import {Hash} from "../../../common/interfaces/hashInterfaces";
  import GloballySelected from "../store/modules/selected";
  import {ObjectModelActionType} from "../../../common/enums/objectModelActionType";
  import scrollToElement from "../../../common/helpers/scrollToElement";
  import DefaultAction from './action-default-action.vue';
  import FillForm from "./action-fill-form.vue";
  import ChangeFieldValues from "./action-change-field-values.vue";
  import CustomNotification from "./action-custom-notification.vue";
  import ViewDocument from "./action-view-document.vue";
  import RunProcess from "./action-run-process.vue";
  import MoveDestroy from "../../../common/components/moveDestroy.vue";
  import ObjectModelActionLabelable from "./object-model-action-labelable.vue";
  import LinkToAccount from "./action-link-to-account.vue";

  export default Vue.extend({
    components: {
      'default-action': DefaultAction,
      "fill-form": FillForm,
      "change-field-values": ChangeFieldValues,
      "custom-notification": CustomNotification,
      "view-document": ViewDocument,
      "run-process": RunProcess,
      "link-to-account": LinkToAccount,
      ObjectModelActionLabelable,
      MoveDestroy,
    },
    mixins: [
        actionBaseMixin,
        routerMixin,
    ],
    data: function() {
      return {
        ObjectModelActionCapability,
        ObjectModelActionDefinition
      };
    },
    mounted() {
      this.selectThisItem();
      if (this.objectModelAction.isSelected) {
        this.scrollToElement();
        if (this.$route.query['selectedId'] !== this.objectModelAction.client_id) {
          this.replaceIdInRoute();
        }
      }
    },
    computed: {
      propertyClasses(): Hash<boolean> {
        return {
          active: this.objectModelAction.isSelected,
          [this.getComponentClass(this.objectModelAction.action_type)]: true,
        };
      },
      isMoveDestroyable(): boolean {
        return this.objectModelAction.action_type !== ObjectModelActionType.DefaultAction;
      },
    },
    methods: {
      selectThisItem(event) {
        if (!this.objectModelAction.isSelected && this.$route.query['selectedId'] === this.objectModelAction.client_id) {
          if (document.activeElement) {
            const $activeEl = $(document.activeElement);
            const $objectModelAction = $activeEl.closest('.object-model-action');
            if ($objectModelAction[0] !== this.$el) {
              $(document.activeElement).blur();
            }
          }
          GloballySelected.objectModelAction.set(this.objectModelAction);
        }
      },
      replaceIdInRoute(): void {
        if (!this.disabled) {
          this.replaceRouteQuery({selectedId: this.objectModelAction.client_id});
        }
      },
      getComponentByType(type: ObjectModelActionType): string {
        return ObjectModelActionDefinition.getComponent(type);
      },
      getComponentClass(type: ObjectModelActionType): string {
        return ObjectModelActionDefinition.getComponentClass(type);
      },
      remove(event): void {
        this.$emit('remove', event);
      },
      scrollToElement(): void {
        scrollToElement({
          $el: $(this.$el),
          $container: $(this.$el).closest('.work-area, .scroll-area'),
          relative: true,
        });
      },
    },
    watch: {
      $route(to, from) {
        if (this.$route.query['selectedId'] === this.objectModelAction.client_id) {
          this.selectThisItem();
          this.$nextTick(() =>{
            this.scrollToElement();
          });
        }
      }
    },
  });
</script>